import { FormArray, FormControl, FormGroup } from '@angular/forms';
import {
  MCGRSettlementScopeFormGroup,
  SettlementScope,
  SettlementScopeDto,
} from '../costs-section/costs-section-form.model';
import {
  MCGROtherSourceSettlementScopeFormGroup,
  OtherSourceSettlementScope,
  OtherSourceSettlementScopeDto,
} from '../other-source-settlement-scope-form-array/other-source-settlement-scope-form-array.model';

export enum MCGRNewRequestEstimatedWorksCostsControlName {
  TotalAmount = 'totalAmount',
  MunicipalFunds = 'municipalFunds',
  OwnFunds = 'ownFunds',
  StateBudgetFunds = 'stateBudgetFunds',
  LocalGovernmentBudgetFunds = 'localGovernmentBudgetFunds',
  OtherFunds = 'otherFunds',
}

export interface MCGREstimatedWorksCostsFormGroup {
  [MCGRNewRequestEstimatedWorksCostsControlName.TotalAmount]: FormControl<
    number | null
  >;
  [MCGRNewRequestEstimatedWorksCostsControlName.MunicipalFunds]: FormGroup<MCGRSettlementScopeFormGroup>;
  [MCGRNewRequestEstimatedWorksCostsControlName.OwnFunds]: FormGroup<MCGRSettlementScopeFormGroup>;
  [MCGRNewRequestEstimatedWorksCostsControlName.StateBudgetFunds]: FormGroup<MCGRSettlementScopeFormGroup>;
  [MCGRNewRequestEstimatedWorksCostsControlName.LocalGovernmentBudgetFunds]: FormGroup<MCGRSettlementScopeFormGroup>;
  [MCGRNewRequestEstimatedWorksCostsControlName.OtherFunds]: FormArray<
    FormGroup<MCGROtherSourceSettlementScopeFormGroup>
  >;
}

export interface EstimatedWorksCosts {
  [MCGRNewRequestEstimatedWorksCostsControlName.TotalAmount]: number;
  [MCGRNewRequestEstimatedWorksCostsControlName.MunicipalFunds]?: SettlementScope;
  [MCGRNewRequestEstimatedWorksCostsControlName.OwnFunds]?: SettlementScope;
  [MCGRNewRequestEstimatedWorksCostsControlName.StateBudgetFunds]?: SettlementScope;
  [MCGRNewRequestEstimatedWorksCostsControlName.LocalGovernmentBudgetFunds]?: SettlementScope;
  [MCGRNewRequestEstimatedWorksCostsControlName.OtherFunds]?: OtherSourceSettlementScope[];
}

export class EstimatedWorksCostsDto {
  constructor(
    public OgolemKwota?: number,
    public SrodkiGminne?: SettlementScopeDto,
    public SrodkiWlasne?: SettlementScopeDto,
    public SrodkiBudzetPanstwa?: SettlementScopeDto,
    public SrodkiBudzetJednostekSamorzadowych?: SettlementScopeDto,
    public SrodkiInne?: OtherSourceSettlementScopeDto[],
  ) {}

  static fromAppToApi(data: EstimatedWorksCosts): EstimatedWorksCostsDto {
    return new this(
      data.totalAmount,
      data.municipalFunds
        ? SettlementScopeDto.fromAppToApi(data.municipalFunds)
        : undefined,
      data.ownFunds
        ? SettlementScopeDto.fromAppToApi(data.ownFunds)
        : undefined,
      data.stateBudgetFunds
        ? SettlementScopeDto.fromAppToApi(data.stateBudgetFunds)
        : undefined,
      data.localGovernmentBudgetFunds
        ? SettlementScopeDto.fromAppToApi(data.localGovernmentBudgetFunds)
        : undefined,
      data.otherFunds?.map((otherFund) =>
        OtherSourceSettlementScopeDto.fromAppToApi(otherFund),
      ),
    );
  }
}
